import domContentLoaded from 'dom-content-loaded';
import { throttle } from 'throttle-debounce';

export default () => {
	let lastInnerWidth;
	domContentLoaded(() => {
		const { body } = document;
		const navTriggers = document.querySelectorAll('.js_menu_trigger, .js_menu_cover');
		const navContents = document.querySelector('.js_menu');
		let sc;
		navTriggers.forEach((navTrigger) => {
			navTrigger.addEventListener('click', () => {
				lastInnerWidth = window.innerWidth;
				const flag = navContents.classList.contains('is_opened');
				if (flag) {
					body.classList.remove('is_locked');
					window.scrollTo(0, sc);
					body.style.top = '';
					navContents.classList.remove('is_opened');
					navContents.classList.add('is_closed');
					for (let i = 0; i < navTriggers.length; i += 1) {
						const trigger = navTriggers[i];
						trigger.classList.remove('is_opened');
						trigger.classList.add('is_closed');
					}
				} else {
					sc = Math.trunc(window.pageYOffset);
					body.style.top = `${sc * -1}px`;
					body.classList.add('is_locked');
					navContents.classList.remove('is_closed');
					navContents.classList.add('is_opened');
					for (let i = 0; i < navTriggers.length; i += 1) {
						const trigger = navTriggers[i];
						trigger.classList.remove('is_closed');
						trigger.classList.add('is_opened');
					}
				}
			});
		});
		// メニュー内のアンカーリンクをクリックしたらメニューを閉じてスムーズスクロール
		const anchorlinks = document.querySelectorAll('.js_menu a[href*="#"]');
		anchorlinks.forEach((anchorlink) => {
			anchorlink.addEventListener('click', (e) => {
				const href = anchorlink.getAttribute('href');
				const hashIndex = href.indexOf('#');
				if (hashIndex === -1) return;

				const targetId = href.slice(hashIndex + 1);
				const targetEl = document.getElementById(targetId);

				// ページ内にターゲットがなければ通常のリンク遷移に任せる
				if (!targetEl) return;

				e.preventDefault();

				// メニューを閉じる
				body.classList.remove('is_locked');
				body.style.top = '';
				window.scrollTo(0, sc);
				navContents.classList.remove('is_opened');
				navContents.classList.add('is_closed');
				const cover = document.querySelector('.js_menu_cover');
				if (cover) {
					cover.classList.remove('is_opened');
					cover.classList.add('is_closed');
				}
				document.querySelectorAll('.js_menu_trigger').forEach((t) => {
					t.classList.remove('is_opened');
					t.classList.add('is_closed');
				});

				// スムーズスクロール（メニューのフェードアウト0.5s後に実行）
				setTimeout(() => {
					const lyHeader = document.querySelector('.ly_header');
					const headerH = lyHeader ? lyHeader.getBoundingClientRect().height : 0;
					const targetTop = targetEl.getBoundingClientRect().top + window.scrollY - headerH;
					window.scrollTo({ top: targetTop, behavior: 'smooth' });
				}, 500);
			});
		});
	});
	window.addEventListener('resize', throttle(200, () => {
		if (lastInnerWidth !== window.innerWidth && window.innerWidth >= 1024 && document.body.classList.contains('is_locked')) {
			document.body.classList.remove('is_locked');
			window.scrollTo(0, 0);
			document.body.style.top = '';
			document.querySelector('.js_menu').classList.remove('is_opened');
			document.querySelector('.js_menu').classList.add('is_closed');
			document.querySelectorAll('.js_menu_trigger,.js_menu_cover').forEach((navTrigger) => {
				navTrigger.classList.remove('is_opened');
				navTrigger.classList.add('is_closed');
			});
		}
	}), false);
};
